import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getPartnerProfiles = (serachQuery, limit = 30) => {
  return api.get(
    `${URLS.partnerProfiles}?limit=${limit}${
      serachQuery ? `&query=${serachQuery}` : ''
    }`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const createPartnerProfile = (profileData) => {
  return api.post(URLS.partnerProfile, profileData, {
    headers: {
      needsToken: true
    }
  });
};

export const getPartnerByID = (partnerID) => {
  return api.get(`${URLS.partnerProfile}?id=${partnerID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updatePartnerProfile = (partnerID, profileData) => {
  return api.put(`${URLS.partnerProfile}?id=${partnerID}`, profileData, {
    headers: {
      needsToken: true
    }
  });
};

export const getPartnerProfileTypes = () => {
  return api.get(URLS.partnerProfileTypes, {
    headers: {
      needsToken: true
    }
  });
};

export const getProfileAttachmentTypes = ({
  profileTypeId,
  page,
  limit = 20,
  query = null,
  isVisible = null,
  isSelectable = null
}) => {
  return api.post(
    URLS.profileAttachmentTypes,
    {
      profileTypeId,
      ...(page && { page }),
      limit,
      ...(query && { query }),
      ...(isVisible !== null && { isVisible }),
      ...(isSelectable !== null && { isSelectable })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateProfileAttachmentType = (attachmentTypeData) => {
  return api.put(URLS.profileAttachmentTypes, attachmentTypeData, {
    headers: {
      needsToken: true
    }
  });
};

export const getPartnerContacts = (partnerID) => {
  return api.get(`${URLS.partnerContacts}?id=${partnerID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const createPartnerContact = (partnerID, contactData) => {
  return api.post(
    `${URLS.partnerContact}?partnerId=${partnerID}`,
    contactData,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getPartnerContactByID = (contactID) => {
  return api.get(`${URLS.partnerContact}?id=${contactID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updatePartnerContact = (partnerID, contactID, contactData) => {
  return api.put(
    `${URLS.partnerContact}?id=${contactID}&partnerId=${partnerID}`,
    contactData,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getPartnerCommunicationsOptions = () => {
  return api.get(URLS.partnerCommunications, {
    headers: {
      needsToken: true
    }
  });
};

export const getClientPurchaseOrderOptions = () => {
  return api.get(URLS.purchaseOrderOptions, {
    headers: {
      needsToken: true
    }
  });
};
export const getClientEmailSubjectFormat = () => {
  return api.get(URLS.emailSubjectFormat, {
    headers: {
      needsToken: true
    }
  });
};

export const getClientProfileDetails = (profileID) => {
  return api.get(`${URLS.clientDetail}?id=${profileID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updateClientProfile = (profileID, profileData) => {
  return api.put(`${URLS.clientDetail}?id=${profileID}`, profileData, {
    headers: {
      needsToken: true
    }
  });
};

export const getProfileComments = (profileID) => {
  return api.get(`${URLS.partnerComments}?id=${profileID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const sendProfileCommnets = (profileId, payload) => {
  return api.post(URLS.partnerComments + `?id=${profileId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteProfileCommnets = (commentId) => {
  return api.delete(`${URLS.partnerComments}?id=${commentId}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updateProfileCommnets = (commentId, payload) => {
  return api.put(`${URLS.partnerComments}?id=${commentId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const getProductFee = (profileID, serachQuery, profileTypeID) => {
  return api.get(URLS.productFee, {
    params: {
      id: profileID,
      ...(serachQuery && { query: serachQuery }),
      profileTypeID: profileTypeID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateProductFee = (profileID, feeData, profileTypeID) => {
  return api.put(URLS.productFee, feeData, {
    params: {
      id: profileID,
      ...(profileTypeID && { profileTypeID: profileTypeID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const productFeeAllUpdate = (id, profileTypeID, data) => {
  return api.put(URLS.productFeeAll, data, {
    params: {
      id: id,
      ...(profileTypeID && { profileTypeID: profileTypeID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const partnerContactResendInvite = (contactID, partnerID) => {
  return api.post(
    URLS.partnerContactResendInvite,
    {
      id: contactID,
      partnerID: partnerID
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const partnerContactToggleStatus = (
  contactID,
  partnerID,
  inactivate
) => {
  return api.post(
    URLS.partnerContactToggleStatus,
    { id: contactID, partnerID: partnerID, inactivate: inactivate },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getPartnerProfileSortList = () => {
  return api.get(URLS.partnerProfilePreviewSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const getPartnerProfileFilterList = () => {
  return api.get(URLS.partnerProfilePreviewFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const getProfileDashboardList = (profileData) => {
  return api.post(URLS.profileDashboard, profileData, {
    headers: {
      needsToken: true
    }
  });
};

export const getProfileProductStatuses = (profileID, profileTypeID) => {
  return api.get(URLS.profileProducts, {
    params: {
      id: profileID,
      profileTypeId: profileTypeID
    },
    headers: {
      needsToken: true
    }
  });
};

export const toggleProfileProductStatus = (data) => {
  return api.post(URLS.profileProducts, data, {
    headers: {
      needsToken: true
    }
  });
};

export const getAbstractorProfile = (profileID) => {
  return api.get(URLS.abstractorProfile, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateAbstractorProfile = (profileID, profileData) => {
  return api.put(URLS.abstractorProfile, profileData, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getT00Profile = (profileID) => {
  return api.get(URLS.t00Profile, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateT00Profile = (profileID, profileData) => {
  return api.put(URLS.t00Profile, profileData, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getWorkshareProfile = (profileID) => {
  return api.get(URLS.workshareProfile, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateWorkshareProfile = (profileID, profileData) => {
  return api.put(URLS.workshareProfile, profileData, {
    params: {
      id: profileID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getPriorityOptions = () => {
  return api.get(URLS.partnerPriorities, {
    headers: {
      needsToken: true
    }
  });
};

export const getBusinessTypes = () => {
  return api.get(URLS.partnerBusinessTypes, {
    headers: {
      needsToken: true
    }
  });
};

export const getAllPartnersWithTypes = (query, data = {}, limit = 10) => {
  return api.post(URLS.allPartnersWithTypes, data, {
    params: {
      ...(query && { query }),
      ...(limit && { limit })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getAdvanceProductFee = ({
  profileID,
  profileTypeID,
  query,
  productID,
  stateID,
  countyID
}) => {
  return api.get(URLS.advanceProductFee, {
    params: {
      id: profileID,
      profileTypeID: profileTypeID,
      ...(query && { query }),
      ...(productID && { productID }),
      ...(stateID && { stateID }),
      ...(countyID && { countyID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateAdvanceProductFee = ({
  profileID,
  profileTypeID,
  productID,
  updatedData
}) => {
  return api.put(
    URLS.advanceProductFee,
    { ...updatedData },
    {
      params: {
        id: profileID,
        profileTypeID: profileTypeID,
        productID: productID
      },
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateAdvanceProductFeeAll = ({
  profileID,
  profileTypeID,
  productID,
  stateID,
  countyID,
  updatedData
}) => {
  return api.put(
    URLS.advanceProductFeeAll,
    { ...updatedData },
    {
      params: {
        id: profileID,
        profileTypeID: profileTypeID,
        ...(productID && { productID }),
        ...(stateID && { stateID }),
        ...(countyID && { countyID })
      },
      headers: {
        needsToken: true
      }
    }
  );
};

export const getPartnerProfileContacts = (profileData, searchInput) => {
  return api.post(URLS.partnerProfileContacts, profileData, {
    params: {
      query: searchInput
    },
    headers: {
      needsToken: true
    }
  });
};
